import React, { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogTitle, DialogContent, Typography, DialogActions } from '@material-ui/core';

const ExcelToJsonComponent = ({ onLoadJson }) => {
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const fileInputRef = useRef(null);
  // CODIGO ORIGINAL
  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(data, { type: 'array' });

  //     const sheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[sheetName];
  //     const json = XLSX.utils.sheet_to_json(worksheet);

  //     onLoadJson && onLoadJson(json);
  //   };
  //   reader.readAsArrayBuffer(file);
  //   event.target.value = '';
  // };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    //  Validar extensión del archivo
    const validExtensions = ['.xlsx', '.xls'];
    const fileName = file.name.toLowerCase();
    const isValid = validExtensions.some(ext => fileName.endsWith(ext));

    if (!isValid) {
      //alert('Por favor selecciona un archivo de Excel (.xlsx o .xls)');
      setOpenWarningDialog(true)
      event.target.value = ''; // limpiar input
      return;
    }

    // Si es válido, continuar
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        onLoadJson && onLoadJson(json);
      } catch (error) {
        alert('El archivo no se pudo procesar. Asegúrate de que sea un archivo Excel válido.');
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = ''; // limpiar el input para permitir volver a subir el mismo archivo
  };


  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div>
      <Button variant='contained' color='secondary' onClick={handleButtonClick} fullWidth>
        Subir Archivo Nómina
      </Button>

      <input
        type='file'
        accept='.xls,.xlsx'
        ref={fileInputRef}
        onChange={handleFileUpload}
        style={{ display: 'none' }}
      />
      <Dialog open={openWarningDialog} onClose={() => setOpenWarningDialog(false)}>
        <DialogTitle style={{ textAlign: 'center' }}>Mensaje</DialogTitle>
        <DialogContent>
          <Typography>Por favor selecciona un archivo de Excel (.xlsx o .xls).</Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', marginTop: '16px' }}>
              <Button
                onClick={() => setOpenWarningDialog(false)}
                style={{ backgroundColor: '#c29914', color: 'white' }}
              >
                Cerrar
              </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

ExcelToJsonComponent.propTypes = {
  onLoadJson: PropTypes.func.isRequired,
};

export default ExcelToJsonComponent;
